// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__hZQf3","colMaxWidth":"Table_colMaxWidth__18W2q"};